<section class="w-full">

  <split-header-section title="Profissionais">
    <p-button label="Cadastrar Profissional" (click)="mostrarCadastro()" severity="primary"></p-button>
  </split-header-section>

  <div [style.padding-right]="'16.002px'" [style.padding-left]="'16.002px'" class="w-full">
    <split-card>
      <div card-header class="grid">
        <div class="col-3">
          <split-search (valueChange)="filterName($event)"></split-search>
        </div>

        <div class="col-9 flex justify-content-end align-items-center">
          <split-group-filter (onFilterEvent)="onFilterChange($event)">
            <split-filter-option field="isActive" [selected]="listActive[0]" label="Ativo" [data]="listActive" key="isActive"></split-filter-option>
            <split-filter-profession #filter field="profession" label="Profissão" key="profession"></split-filter-profession>
            <split-filter-unit #filter field="units" label="Unidade" key="units"></split-filter-unit>
            <split-filter-specialties #filter field="specialties.id" label="Especialidades" key="specialties"></split-filter-specialties>
            <split-filter-dropdown field="issueInvoice" label="NF" [data]="condicionalData" key="issueInvoice"></split-filter-dropdown>
            <split-filter-dropdown field="split" label="Split" [data]="condicionalData" key="split"></split-filter-dropdown>
        </split-group-filter>
          <!-- <split-button-filter></split-button-filter> -->
        </div>
      </div>
      <ng-container card-body>
          <split-table #idTable [filters]="filters" [paginator]="true" [loading]="isLoading" [totalRecords]="totalItems" (pageChange)="onPageChange($event)" [widthColumns]="[25, 10, 25, 15, 5, 5, 15]"
                       [dados]="professionalList" theme="primary">

          <ng-template #header>
            <div class="w-full text-center">Nome</div>
          </ng-template>
          <ng-template #coluna let-item="dadosLinha">
            <div class="flex align-items-center" [ngClass]="item.isActive == false? 'inativo': ''">
              <!-- <img *ngIf="true" src="/assets/avatar/Avatar.png" alt="foto de perfil" class="mr-3 profile" /> -->
              <div class="text-left  ml-3" [style.max-width]="'20rem'">
                <split-text [title]="item.name" [subtitle]="item.email" [position]="'left'"></split-text>
              </div>
            </div>
          </ng-template>

          <ng-template #header>Telefone</ng-template>
          <ng-template #coluna let-item="dadosLinha">
            <div [ngClass]="item.isActive == false? 'inativo': ''">
              {{ item.contactNumber | formatPhoneNumber}}
            </div>
          </ng-template>

          <ng-template #header>Profissão/Especialidade</ng-template>
          <ng-template #coluna let-item="dadosLinha">
            <div [ngClass]="item.isActive == false? 'inativo': ''">
              <p class="block">
                <!-- {{ item.profession.name }} -->
                {{setProfessionName(item.profession)}}
              </p>
              <p style="color: #999999">
                {{ item.specialties?.length > 0 ? formataEspecialidades(item.specialties): '' }}

              </p>
            </div>
          </ng-template>

          <ng-template #header>Unidades</ng-template>
          <ng-template #coluna let-item="dadosLinha">
            <div [ngClass]="item.isActive == false? 'inativo': ''">
              <split-list-badge [maxWidth]="'15rem'" [list]="mapUnidadeName(item.units)"></split-list-badge>
            </div>
          </ng-template>

          <ng-template #header>Split</ng-template>
          <ng-template #coluna let-item="dadosLinha">
            <!-- <p-progressSpinner [style]="{width: '20px', height: '20px'}"></p-progressSpinner> -->

            <div [ngClass]="item.isActive == false? 'inativo': ''">

              <ng-container  *ngIf="item.split == false">
                <i [pTooltip]="'Esse Profissional não possui Split ativado'"
                style="color: #fbc02d" class="pi pi-exclamation-circle"></i>
              </ng-container>

              <ng-container  *ngIf="item.split == true">

                <ng-container *ngIf="item.taxInfo?.statusRecipientExternal != 'active'" >
                  <i *ngIf="item.taxInfo?.statusRecipientExternal == 'pending'" [pTooltip]="'Pendente'" style="color: #fbc02d" class="pi pi-spin pi-spinner"></i>
                  <i *ngIf="item.taxInfo?.statusRecipientExternal == 'registration'" [pTooltip]="'Pendente'" style="color: #fbc02d" class="pi pi-spin pi-spinner"></i>
                  <i *ngIf="item.taxInfo?.statusRecipientExternal == 'affiliation'" [pTooltip]="'Pendente'" style="color: #fbc02d" class="pi pi-spin pi-spinner"></i>
                  <i *ngIf="item.taxInfo?.statusRecipientExternal == 'refused'" [pTooltip]="'Cadastro Recusado'" style="color: rgb(255, 3, 3)" class="pi pi-times"></i>
                  <i *ngIf="item.taxInfo?.statusRecipientExternal == 'suspended'" [pTooltip]="'Cadastro Suspenso, o recebedor não fez o auto credenciamento'" style="color: #fbc02d" class="pi pi-exclamation-circle"></i>
                  <i *ngIf="item.taxInfo?.statusRecipientExternal == 'blocked'" [pTooltip]="'Cadastro Bloqueado'" style="color: rgb(255, 3, 3)" class="pi pi-ban"></i>
                  <i *ngIf="item.taxInfo?.statusRecipientExternal == 'inactive'" [pTooltip]="'Cadastro Inativo'" style="color: rgb(255, 3, 3)" class="pi pi-exclamation-circle"></i>
                </ng-container>

                <ng-container *ngIf=" item.taxInfo?.statusRecipientExternal == 'active'">
                  <i [pTooltip]="'Cadastro Ativo'" style="color: #0a8300" class="pi pi-check-circle"></i>
                </ng-container>

                <!-- <i *ngIf="item.taxInfo?.recipientActive" style="color: #0a8300" class="pi pi-check-circle"></i>
                <i *ngIf="item.taxInfo?.recipientActive == false" style="color: #fa0505" class="pi pi-exclamation-circle"
                [pTooltip]="errorSplitTemplate"></i> -->
              </ng-container>


            </div>
            <ng-template #errorSplitTemplate>
              <ul class="p-0 pl-4 pr-1">
                <li *ngIf="!item.taxInfo?.recipientActive">
                  Atualize seus Dados Bancários
                </li>
              </ul>
            </ng-template>
          </ng-template>

          <ng-template #header>NF</ng-template>
          <ng-template #coluna let-item="dadosLinha">
            <div [ngClass]="item.isActive == false? 'inativo': ''">

              <i *ngIf="item.entityType != 'pj-emissao-automatica-nf'" [pTooltip]="'Esse Profissional não emite nota fiscal'"
                style="color: #fbc02d" class="pi pi-exclamation-circle"></i>

              <ng-container *ngIf="item.split && item.entityType == 'pj-emissao-automatica-nf'">
                <i *ngIf="item.taxInfo?.issuerPartnerId?.length && item.taxInfo?.digitalCertificationFile?.length"
                  style="color: #0a8300" class="pi pi-check-circle"></i>
                <i *ngIf="!item.taxInfo?.issuerPartnerId?.length || !item.taxInfo?.digitalCertificationFile?.length"
                  style="color: #fa0505" class="pi pi-exclamation-circle" [pTooltip]="errorTemplate"></i>
              </ng-container>
            </div>

            <ng-template #errorTemplate>
              <ul class="p-0 pl-4 pr-1 my-1">
                <li *ngIf="!item.taxInfo?.issuerPartnerId?.length">
                  Verifique seus Dados Fiscais
                </li>
                <li class="my-1" *ngIf="!item.taxInfo?.digitalCertificationFile?.length">
                  Verifique seu Certificado Digital
                </li>
              </ul>
            </ng-template>
          </ng-template>

          <!-- <ng-template #header>Prova de Vida</ng-template>
          <ng-template #coluna let-item="dadosLinha">

            <ng-container  *ngIf="item.split == false">
              <i [pTooltip]="'Esse Profissional não possui Split ativado, portanto não necessita prova de vida'"
              style="color: #fbc02d" class="pi pi-exclamation-circle"></i>
            </ng-container>

            <ng-container  *ngIf="item.split == true">

              <ng-container *ngIf="item.taxInfo?.statusRecipientExternal != 'active'" >
                <i [pTooltip]="'O cadastro ainda não está ativo'"
                style="color: #fbc02d" class="pi pi-exclamation-circle"></i>
              </ng-container>

              <ng-container *ngIf=" item.taxInfo?.statusRecipientExternal == 'active'">
                <ng-container *ngIf="item.taxInfo?.isProofActiveLife == true" >
                  <i [pTooltip]="'Cadastro Ativo'" style="color: #0a8300" class="pi pi-check-circle"></i>
                </ng-container>

                <ng-container *ngIf="item.taxInfo?.isProofActiveLife == false">
                  <p-button
                    (onClick)="op.toggle($event)"
                    icon="pi pi-exclamation-circle"
                    [rounded]="true"
                    [text]="true"
                    severity="danger"
                  />
                  <p-overlayPanel #op (onHide)="onHideOverlayPanel()">
                    <div class="flex flex-column align-items-center w-16rem">
                      <span>Copiar link ou enviar por email</span>
                      <div class="p-inputgroup mt-3 w-15rem border-round-md" [style]="'border: 1px solid #BDBDBD !important;'">
                          <input
                            class="px-2 text-overflow-ellipsis"
                            type="text"
                            pInputText
                            readonly
                            [value]="item.taxInfo?.proofLifeLink"
                          />
                          <button
                            class="h-2rem border-noround"
                            (click)="onCopyText(item.taxInfo?.proofLifeLink)"
                            [style]="' background-color: #BDBDBD'"
                            type="button"
                            pButton
                            [icon]="copyButtonIcon"
                          ></button>
                      </div>

                      <button
                        (click)="onSubmitLinkByEmail(item.id)"
                        class="w-15rem mt-2 btn-split btn-split-orange h-2rem border-round-md"
                      > enviar link por email </button>
                    </div>
                  </p-overlayPanel>
                </ng-container>
              </ng-container>


            </ng-container>
          </ng-template> -->

          <ng-template #header></ng-template>
          <ng-template #coluna let-item="dadosLinha">
            <div class="flex align-items-center justify-content-around">

              <div [ngClass]="item.isActive == false? 'inativo': ''">
                <p-button [rounded]="true" severity="secondary" [text]="true" (click)="editarCadastro(item)"
                  pTooltip="Editar Profissional">
                  <ng-template pTemplate="icon">
                    <div class="flex">
                      <split-icon name="edit" [size]="18"></split-icon>
                    </div>
                  </ng-template>
                </p-button>
              </div>
              <div [ngClass]="item.isActive == false? 'inativo': ''">
                <p-button [rounded]="true" severity="secondary" [text]="true" pTooltip="Listar Serviços"
                  (click)="editarCadastro(item, true)">
                  <ng-template pTemplate="icon">
                    <div class="flex">
                      <split-icon name="tasklist" [size]="18"></split-icon>
                    </div>
                  </ng-template>
                </p-button>
              </div>

              <div *ngIf="item.isActive">
                <button class="btn-split-icon btn-block-primary" (click)="dialogInativar(item)"
                  pTooltip="Inativar Profissional"></button>
              </div>

              <div *ngIf="!item.isActive">
                <button class="action border-circle bg-white w-2rem h-2rem " (click)="ativarItem(item)"
                  pTooltip="Ativar Profissional">
                  <img src="assets/cadastro/active.svg" alt="ativar Profissional" />
                </button>
              </div>

              <button class="btn-split-icon btn-delete-danger hidden" (click)="dialogExcluir(item)"
                pTooltip="Deletar Profissional"></button>
            </div>
          </ng-template>

        </split-table>
      </ng-container>
    </split-card>
  </div>


</section>

<!-- dialog confirmação deletar / inativar -->
<p-dialog [(visible)]="mostrarModalExcluir" [dismissableMask]="true" styleClass="pDialog" [draggable]="false"
  [modal]="true">
  <div class="content">
    <img src="assets/lista-unidade/modal-deletar/deletar-unidade.svg" alt="imagem deletar funcionario">
    <span class="title">
      <p>Tem certeza que deseja deletar</p>
      <p>esse profissional?</p>
    </span>
    <span class="message">
      <p>Ao confirmar você excluirá permanentemente</p>
      <p>o profissional selecionado</p>
    </span>
  </div>
  <ng-template pTemplate="footer">
    <button class="cancelar" (click)="dialogExcluir()">Cancelar</button>
    <button class="deletar" (click)="excluirItem()">Deletar</button>
  </ng-template>

</p-dialog>


<p-dialog [(visible)]="mostrarModalInativar" [dismissableMask]="true" styleClass="pDialog" [draggable]="false"
  [modal]="true">
  <div [style.width]="'23rem'" [style.height]="'17rem'" *ngIf="(professionalState$ | async)!.type == 'loading' "
    class="flex align-items-center justify-content-center">
    <p-progressSpinner ariaLabel="loading"></p-progressSpinner>
  </div>
  <div *ngIf="(professionalState$ | async)!.type != 'loading' " class="content" [style.width]="'23rem'"
    [style.height]="'17rem'">
    <img src="assets/lista-unidade/modal-inativar/inativar-unidade.svg" alt="imagem inativar funcionario">
    <span class="title">
      <p>Tem certeza que deseja inativar</p>
      <p>esse profissional?</p>
    </span>
    <span class="message">
      <p>Ao confirmar você inativará esse profissional da sua listagem</p>
      <p>padrão.</p>
    </span>
  </div>
  <ng-template pTemplate="footer">
    <button class="cancelar" (click)="dialogInativar()">Cancelar</button>
    <button class="inativar" (click)="inativarItem()">Inativar</button>
  </ng-template>

</p-dialog>

<p-dialog [(visible)]="mostrarModalAtivar" [dismissableMask]="true" styleClass="pDialog" [draggable]="false"
  [modal]="true">

  <div [style.width]="'23rem'" [style.height]="'17rem'" *ngIf="(professionalState$ | async)!.type == 'loading' "
    class="flex align-items-center justify-content-center">
    <p-progressSpinner ariaLabel="loading"></p-progressSpinner>
  </div>

  <div *ngIf="(professionalState$ | async)!.type != 'loading' " class="content" [style.width]="'23rem'"
    [style.height]="'17rem'">
    <img src="assets/cadastro/active_modal.svg" alt="imagem deletar funcionario">
    <span class="title">
      <p>Tem certeza que deseja ativar</p>
      <p>esse profissional?</p>
    </span>
    <span class="message">
      <p>Ao confirmar você irá ativar esse profissional na sua listagem</p>
      <p> padrão</p>
    </span>
  </div>
  <ng-template pTemplate="footer">
    <button class="cancelar" (click)="fecharDialog()">Cancelar</button>
    <button class="ativar" (click)="ativarItemPatch()">Ativar</button>
  </ng-template>

</p-dialog>
